import {useState} from "react";
import {
    autoUpdate,
    flip,
    offset,
    shift,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
    useRole,
    size,
    Elements
} from "@floating-ui/react";
import { HEADER_MENU_VARIANT } from "../../header-menu/header-menu";

const useFloatingMenu = (variant?: HEADER_MENU_VARIANT) => {
    const [isOpen, setIsOpen] = useState(false);

    const applyVarinatSize = (elements: Elements) => {
        if (variant && variant === HEADER_MENU_VARIANT.PORTAL_SELECT_MENU) {
            const targetWidth = () => {
                const minDropdownWidth = 250;
                const referenceWidth = refs.domReference.current?.closest('.portal-selection')?.clientWidth;
                if (referenceWidth && referenceWidth > minDropdownWidth) {
                    return referenceWidth;
                }

                return minDropdownWidth;
            }

            Object.assign(elements.floating.style, {
                width: `${targetWidth()}px`,
            });
        }
    };

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: 'bottom-start',
        middleware: [
            offset(10), 
            flip(), 
            shift(),

            size({
                apply({ elements }) {
                    applyVarinatSize(elements);                    
                },
            }),

        ], // Plugins for positioning
        whileElementsMounted: autoUpdate, // Auto-update position on scroll/resize
    });

    // --- Interaction Hooks ---
    // useClick makes the dropdown open/close on button click
    const click = useClick(context);
    // useDismiss allows closing the dropdown by clicking outside or pressing Escape
    const dismiss = useDismiss(context);
    // useRole adds appropriate ARIA attributes for accessibility
    const role = useRole(context);
    // Merge all interaction hooks into a single set of props
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss,
        role,
    ]);

    return {
        isOpen,
        setIsOpen,
        refs,
        floatingStyles,
        context,
        getReferenceProps,
        getFloatingProps,
    };
}

export default useFloatingMenu;